import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  t: "1663211946957",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "3135",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M421.728 574.848l0 372-389.728-53.728 0-318.272 389.728 0zM421.728 150.272l0 376.576-389.728 0 0-322.848zM982.848 574.848l0 449.152-518.272-71.424 0-377.728 518.272 0zM982.848 73.152l0 453.728-518.272 0 0-382.272z",
      "p-id": "3136",
      fill: "#ffffff"
    }, null, -1)
  ]))]))
}
export default { render: render }